(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('copy', (e) => {
    const sel = window.getSelection();
    const node = sel.anchorNode?.parentElement;

    if (node?.dataset.text) {
      e.clipboardData.setData('text/plain', node.dataset.text.trim());
      e.preventDefault();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
